import './AccountPages.scss'
import React, { useEffect } from 'react'
import { BrickResolver } from '@src/utils/BrickResolver'
import usePageContextData from '@src/utils/brickresolvers/usePageContextData'
import { pushSubscribe } from '@src/api/facebook/facebook'
import { googleAnalytics } from '@src/api/googleanalytics/googleAnalytics'
import { useConnect } from 'redux-bundler-hook'
import { SITE_TYPES } from '@src/bundles/site'
import { localizedUrl } from '@src/utils/navigate'
import { loadToken } from '@src/utils/tokenUtils'

function SuccessPage({ customPageContext }) {
	const {
		customerInfo,
		doSetSiteType,
		doRefreshCustomerInfo,
		language,
		businessCustomer,
		service,
		doSetMembership,
	} = useConnect(
		'selectCustomerInfo',
		'doSetSiteType',
		'doRefreshCustomerInfo',
		'selectLanguage',
		'selectBusinessCustomer',
		'selectService',
		'doSetMembership',
	)

	useEffect(() => {
		doRefreshCustomerInfo()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		if (businessCustomer) {
			doSetSiteType(SITE_TYPES.BUSINESS)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		pushSubscribe('0.00', 'USD', '0.00')
		googleAnalytics.pushVirtualPageView(
			`/virtual/account/successpage/${customerInfo.customerId}`,
			`User with userid ${customerInfo.customerId} have successfully become a member`,
		)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const azureData = {
		token: loadToken(),
	}

	const addMembership = async () => {
		if (
			sessionStorage.getItem('membership') !== null &&
			customerInfo.validPaymentCard === true
		) {
			try {
				const requestOptions = {
					method: 'POST',
					headers: {
						'Ocp-Apim-Subscription-Key': process.env.GATSBY_MM_API_GATEWAY_KEY,
						'Telematics-AuthToken': azureData.token,
					},
					body: JSON.stringify({
						membership_id: sessionStorage.getItem('membership'),
						kinto_product: service,
					}),
				}
				fetch(
					`${process.env.GATSBY_MM_API_GATEWAY_BASE_URL}/customer/membership/`,
					requestOptions,
				)
			} catch (error) {
				// No error handling for now
			}
		}
	}

	useEffect(() => {
		addMembership()
		doSetMembership()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [customerInfo.validPaymentCard])

	return (
		<BrickResolver
			pageContext={usePageContextData({
				pageName:
					sessionStorage.getItem('membership') !== null &&
					customerInfo.validPaymentCard === true
						? localizedUrl('/accountMembership', language, service)
						: localizedUrl('/account', language, service),
			})}
		></BrickResolver>
	)
}

export default SuccessPage
